/* WoodenCrew — Add to cart fallback when the theme mini-cart drawer is off (v2, 2026-10-17).
 * With Theme settings "show_minicart_options" = false the theme does not render
 * #form-mini-cart, but its product-form JS still (1) asks /cart/add to render the
 * "form-mini-cart" section — slow on Shopify's side (0.9–20 s measured vs ~0.6 s without) —
 * and (2) tries to put that HTML into the missing drawer, crashing silently.
 * This patch, only while #form-mini-cart is missing:
 *   - removes sections=form-mini-cart from /cart/add requests (fast response),
 *   - skips the drawer re-render and opens the /cart page right after the add.
 * When the drawer is turned back on (#form-mini-cart exists) the theme works as before.
 */
(function () {
  'use strict';
  if (window.__wcCartNoDrawer) return;
  window.__wcCartNoDrawer = true;

  var SECTION = 'form-mini-cart';
  function noDrawer() { return !document.getElementById(SECTION); }
  function cartUrl() { return (window.routes && window.routes.cart_url) || '/cart'; }
  function onCartPage() {
    return location.pathname.replace(/\/$/, '') === cartUrl().replace(/\/$/, '');
  }

  /* 1. Drop the unused drawer section from /cart/add requests */
  function stripSections(input, init) {
    try {
      if (!init || !init.body || !noDrawer()) return;
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (!/\/cart\/add(\.js)?(\?|$)/.test(String(url))) return;
      var b = init.body;
      if (typeof FormData !== 'undefined' && b instanceof FormData) {
        if (b.get('sections') === SECTION) { b.delete('sections'); b.delete('sections_url'); }
      } else if (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) {
        if (b.get('sections') === SECTION) { b.delete('sections'); b.delete('sections_url'); }
      } else if (typeof b === 'string' && b.charAt(0) === '{') {
        var j = JSON.parse(b);
        if (j && j.sections === SECTION) {
          delete j.sections; delete j.sections_url;
          init.body = JSON.stringify(j);
        }
      }
    } catch (e) { /* never block the add */ }
  }
  var prevFetch = window.fetch;
  if (prevFetch) {
    window.fetch = function (input, init) {
      stripSections(input, init);
      return prevFetch.apply(this, arguments);
    };
  }

  /* 2. No drawer re-render; go to /cart instead */
  function patch() {
    var C = window.customElements && customElements.get('cart-notification');
    if (!C) return false;
    var p = C.prototype;
    if (p.__wcNoDrawerPatch) return true;
    var gs = p.getSectionsToRender, ca = p.cartAction, op = p.open;
    p.getSectionsToRender = function () { return noDrawer() ? [] : gs.apply(this, arguments); };
    p.cartAction = function () { if (noDrawer()) return; return ca.apply(this, arguments); };
    p.open = function () {
      if (noDrawer()) {
        if (!onCartPage()) location.href = cartUrl();
        return;
      }
      return op.apply(this, arguments);
    };
    p.__wcNoDrawerPatch = true;
    return true;
  }
  if (!patch() && window.customElements) customElements.whenDefined('cart-notification').then(patch);
})();
